import { RJSFSchema } from "@rjsf/utils/lib/types";

export const ps_skip_page_rule_1 = (dataStore: Record<string, any>) => {
  return dataStore?.p_base?.fs_got_product?.got_product === "no" || dataStore?.p_base?.fs_application?.how_often === "never";
};
export const postsurvey_clean_on_submit = (dataStore: Record<string, any>) => {
  if (dataStore.p_base.fs_got_product && dataStore?.p_base?.fs_got_product?.got_product !== "yes") {
    dataStore.p_base.fs_got_product.got_which_product = undefined;
    dataStore.p_base.fs_workshop_urge_reflex = undefined;
    dataStore.p_base.fs_application = undefined; // p_consolidation_all_users_2
  }

  if (dataStore?.p_base?.fs_why_not?.why_no_sleep && !dataStore.p_base.fs_why_not.why_no_sleep.includes("other")) {
    dataStore.p_base.fs_why_not.why_no_sleep_other_field = undefined;
  }

  if (dataStore.p_base.fs_why_not && dataStore?.p_base?.fs_got_product?.got_product !== "no") {
    dataStore.p_base.fs_why_not.why_no_sleep_other_field = undefined;
    dataStore.p_base.fs_why_not.why_no_sleep = undefined;
  }
  if (dataStore?.p_base?.fs_osas && dataStore?.p_base?.fs_osas?.evaluation_sleep !== "yes") {
    dataStore.p_base.fs_osas.result_evaluation_sleep_efficacy = undefined;
    dataStore.p_base.fs_osas.result_evaluation_sleep = undefined;
  }

  if (
    dataStore?.p_consolidation_all_users_2?.fs_qm_service &&
    dataStore?.p_consolidation_all_users_2?.fs_qm_service?.qm_was_group_ws !== "yes"
  ) {
    dataStore.p_consolidation_all_users_2.fs_qm_service.qm_group_ws_fell = undefined;
  }
};

export const postsurvey_on_change_rule = (dataStore: Record<string, any>, localParamData: Record<string, any>) => {
  if (!("p_base" in dataStore)) {
    dataStore["p_base"] = {};
  }
  if (!("p_consolidation_all_users_2" in dataStore)) {
    dataStore["p_consolidation_all_users_2"] = {};
  }
  // state_no_product_received;
  if (localParamData?.intro === 0 && localParamData?.original === 0) {
    dataStore["p_base"].state_no_product_received = -1;
    if (dataStore?.p_base?.fs_got_product?.got_product === "yes") {
      dataStore["p_base"].state_no_product_received = 0;
    }
    if (dataStore?.p_base?.fs_got_product?.got_product === "no") {
      dataStore["p_base"].state_no_product_received = 1;
    }
  } else {
    dataStore["p_base"].state_no_product_received = 0;
  }

  dataStore["p_consolidation_all_users_2"].state_no_product_applicable = dataStore?.p_base?.fs_application?.how_often === "never" ? 1 : 0;
  dataStore["p_base"].state_no_product_recived_or_applicable =
    dataStore["p_base"].state_no_product_received === 1 || dataStore["p_consolidation_all_users_2"].state_no_product_applicable ? 1 : 0;

  // REQUIRED FILEDS
  if (dataStore?.p_base && !("fs_got_product" in dataStore.p_base)) {
    dataStore["p_base"].fs_got_product = {};
  }
  if (dataStore?.p_base?.fs_got_product && !("got_product" in dataStore.p_base.fs_got_product)) {
    dataStore["p_base"].fs_got_product.got_product = undefined;
  }
};

export const postsurvey_steps = (t: (lang: string, params?: Record<string, string>) => string) => [
  { title: t("survey.postsurvey.start.title") },
  { title: t("survey.postsurvey.p_base.title"), notEmpty: true },
  { title: t("survey.postsurvey.p_consolidation_users_only.title"), skipRules: [ps_skip_page_rule_1] },
  { title: t("survey.postsurvey.p_consolidation_all_users.title") },
  { title: t("survey.postsurvey.p_consolidation_all_users_2.title") },
];

export const postsurveySchema = (t: (s: string) => string, page: number, paramsData: Record<string, any>): RJSFSchema => {
  const schema: RJSFSchema = {
    type: "object",
    title: "",
    properties: {
      start: {
        type: "object",
        description: "",
      },
      contact_id: {
        title: "contact_id",
        type: "number",
      },
      info_id: {
        title: "info_id",
        type: "number",
      },
      cpap: {
        title: "cpap",
        type: "number",
      },
      osas_des: {
        title: "osas_des",
        type: "number",
      },
      original: {
        title: "original",
        type: "number",
      },
      intro: {
        type: "number",
      },
    },
  };

  if (page === 0 || page === 999) {
    (schema.properties!.start as any).description = t("survey.postsurvey.start.fs_introduction.description");
  }

  if (page === 1 || page === 999) {
    const no_product_detected = (paramsData as any).original === 0 && (paramsData as any).intro === 0;
    const both_products_delivered = (paramsData as any).original === 1 && (paramsData as any).intro === 1;

    (schema.properties as any).p_base = {
      type: "object",
      title: "",
      properties: {
        state_no_product_received: {
          type: "number",
          default: 0,
        },
        state_no_product_recived_or_applicable: {
          type: "number",
        },
        ...(both_products_delivered
          ? {
              fs_which_product: {
                type: "object",
                title: "",
                properties: {
                  fs_which_product_title: {
                    title: t("survey.postsurvey.p_base.fs_which_product.title"),
                    type: "string",
                  },
                  which_product: {
                    title: t("survey.postsurvey.p_base.fs_which_product.which_product.title"),
                    description: t("survey.postsurvey.p_base.fs_which_product.which_product.description"),
                    type: "string",
                    enum: ["original", "intro"],
                  },
                },
                required: ["which_product"],
                description: "",
              },
            }
          : {}),

        ...(no_product_detected
          ? {
              fs_got_product: {
                type: "object",
                title: "",
                properties: {
                  fs_got_product_title: {
                    title: t("survey.postsurvey.p_base.fs_got_product.title"),
                    type: "string",
                  },
                  got_product: {
                    title: t("survey.postsurvey.p_base.fs_got_product.got_product.title"),
                    type: "string",
                    enum: ["yes", "no"],
                  },
                },
                required: ["got_product"], // Apply required directly here
                dependencies: {
                  got_product: {
                    oneOf: [
                      {
                        properties: {
                          got_product: {
                            const: "yes",
                          },
                          got_which_product: {
                            title: t("survey.postsurvey.p_base.fs_got_product.got_which_product.title"),
                            description: "",
                            type: "string",
                            enum: ["original", "intro"],
                          },
                        },
                      },
                      {
                        properties: {
                          got_product: {
                            const: "no",
                          },
                        },
                      },
                      {
                        properties: {
                          got_product: {
                            const: null,
                          },
                        },
                      },
                    ],
                  },
                },
              },
            }
          : {}),
      },

      // required: [...(no_product_detected ? ["fs_got_product.got_product"] : [])],
      dependencies: {
        state_no_product_received: {
          oneOf: [
            {
              properties: {
                state_no_product_received: {
                  const: 1,
                },
              },
            },
            {
              properties: {
                state_no_product_received: {
                  const: -1,
                },
              },
            },
            {
              properties: {
                state_no_product_received: {
                  const: 0,
                },

                fs_application: {
                  type: "object",
                  title: "",
                  // title: t("survey.postsurvey.p_base.fs_application.title"),

                  properties: {
                    fs_application_title: {
                      title: t("survey.postsurvey.p_base.fs_application.title"),
                      type: "string",
                    },

                    sleep: {
                      title: t("survey.postsurvey.p_base.fs_application.sleep.title"),
                      type: "string",
                      enum: ["yes", "no"],
                    },
                    wellbeing: {
                      title: t("survey.postsurvey.p_base.fs_application.wellbeing.title"),
                      type: "string",
                      enum: ["yes", "no"],
                    },
                    how_often: {
                      title: t("survey.postsurvey.p_base.fs_application.how_often.title"),
                      type: "string",
                      enum: ["almost always", "often", "sometimes", "rare", "never"],
                    },
                  },
                },

                fs_workshop_urge_reflex: {
                  type: "object",
                  title: "",
                  // title: t("survey.postsurvey.p_base.fs_workshop_urge_reflex.title"),
                  properties: {
                    fs_workshop_urge_reflex_title: {
                      type: "string",
                      title: t("survey.postsurvey.p_base.fs_workshop_urge_reflex.title"),
                    },
                    urge_reflex_nausea: {
                      title: t("survey.postsurvey.p_base.fs_workshop_urge_reflex.urge_reflex_nausea.title"),
                      type: "string",
                      enum: ["practically not exist", "only light", "exsit but conquerable", "strong but conquerable", "not conquerable"],
                    },
                    urge_reflex_real_imagined: {
                      title: t("survey.postsurvey.p_base.fs_workshop_urge_reflex.urge_reflex_real_imagined.title"),
                      type: "string",
                      enum: ["less than imagined", "what I expexted", "stronger than imagined"],
                    },
                  },
                },
              },
            },
          ],
        },
        state_no_product_recived_or_applicable: {
          oneOf: [
            {
              properties: {
                state_no_product_recived_or_applicable: {
                  const: 1,
                },

                fs_why_not: {
                  type: "object",
                  title: t("survey.postsurvey.p_base.fs_why_not.title"),
                  properties: {
                    why_no_sleep: {
                      title: t("survey.postsurvey.p_base.fs_why_not.why_no_sleep.title"),
                      type: "array",
                      items: {
                        type: "string",
                        enum: ["too strong urge reflex", "pain when applying", "to small pharynx", "other"],
                      },
                      uniqueItems: true,
                    },
                  },
                  dependencies: {
                    why_no_sleep: {
                      oneOf: [
                        {
                          properties: {
                            why_no_sleep: {
                              type: "array",
                              contains: {
                                const: "other",
                              },
                            },
                            why_no_sleep_other_field: {
                              title: t("survey.postsurvey.p_base.fs_why_not.why_no_sleep_other_field.title"),
                              type: "string",
                            },
                          },
                        },
                        {
                          properties: {
                            why_no_sleep: {
                              type: "array",
                              not: {
                                contains: {
                                  const: "other",
                                },
                              },
                            },
                          },
                        },
                      ],
                    },
                  },
                },
              },
            },
            {
              properties: {
                state_no_product_recived_or_applicable: {
                  const: 0,
                },
              },
            },
          ],
        },
      },

      //   }
      // : {}),
      description: "",
    };
  }

  if (page === 2 || page === 999) {
    const has_cpap = (paramsData as any).cpap === 1;
    const has_osas = (paramsData as any).osas_des === 1;

    // const uses_product = false;
    schema.properties!.p_consolidation_users_only = {
      type: "object",
      title: "",
      properties: {
        fs_habituation_period: {
          type: "object",
          title: "",
          // "#states": { invisible: [{ ':input[name="got_product"': "no" }, "xor", { ':input[name="how_often"': "never" }] },
          properties: {
            fs_habituation_period_title: {
              title: t("survey.postsurvey.p_consolidation_users_only.fs_habituation_period.title"),
              type: "string",
            },
            duration_habituation: {
              title: t("survey.postsurvey.p_consolidation_users_only.fs_habituation_period.duration_habituation.title"),
              description: "",
              type: "string",
              enum: ["from first night", "1-3 nights", "ca. one week", "ca. 2-3 weeks", "longer", "dontknow"],
            },
            relaxed_2: {
              title: t("survey.postsurvey.p_consolidation_users_only.fs_habituation_period.relaxed_2.title"),
              description: "",
              type: "string",
              enum: ["almost always", "often", "sometimes", "rare", "never"],
            },
          },
          description: "",
        },
        fs_snoring: {
          type: "object",
          title: "",
          properties: {
            fs_snoring_title: {
              title: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.title"),
              type: "string",
            },
            snoring_observed: {
              type: "object",
              title: t("survey.postsurvey.p_consolidation_users_only.fs_snoring.snoring_observed.title"),
              // description: "",
              rows: {
                type: "array",
                enum: ["snoring_observed_0", "snoring_observed_1"],
              },
              columns: {
                type: "array",
                enum: ["never", "sometimes but shortly", "ca 2 houres", "ca 4 houres", "always", "unknowen"],
              },
            } as any,

            self_assess_suffer_2: {
              type: "object",
              title: t("survey.custom.assess_suffer.self_assess_suffer_2.title"),
              rows: {
                type: "array",
                enum: ["self_assess_suffer_2_0", "self_assess_suffer_2_1"],
              },
              columns: {
                type: "array",
                enum: ["well bearable", "rather well bearable", "medium", "rather unbearable", "unbearable"],
              },
            } as any,

            suffer_person_concerned_2: {
              type: "object",
              title: t("survey.custom.assess_suffer.suffer_person_concerned_2.title"),
              rows: {
                type: "array",
                enum: ["suffer_person_concerned_2_0", "suffer_person_concerned_2_1"],
              },
              columns: {
                type: "array",
                enum: ["well bearable", "rather well bearable", "medium", "rather unbearable", "unbearable"],
              },
            } as any,
          },
          description: "",
        },

        ...(has_osas
          ? {
              fs_osas: {
                type: "object",
                title: "",
                properties: {
                  fs_osas_title: {
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_osas.title"),
                    type: "string",
                  },
                  improved_sleep_with_velumount: {
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_osas.improved_sleep_with_velumount.title"),
                    description: "",
                    type: "string",
                    enum: ["yes", "no"],
                  },
                  evaluation_sleep: {
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_osas.evaluation_sleep.title"),
                    description: "",
                    type: "string",
                    enum: ["yes", "no"],
                  },
                },
                dependencies: {
                  evaluation_sleep: {
                    oneOf: [
                      {
                        properties: {
                          evaluation_sleep: {
                            const: "yes",
                          },
                          result_evaluation_sleep_efficacy: {
                            title: t("survey.postsurvey.p_consolidation_users_only.fs_osas.result_evaluation_sleep_efficacy.title"),
                            description: "",
                            type: "string",
                            enum: ["verybad", "bad", "part_part", "good", "better"],
                          },
                          results_evaluation_sleep: {
                            title: t("survey.postsurvey.p_consolidation_users_only.fs_osas.results_evaluation_sleep.title"),
                            description: "",
                            type: "string",
                            enum: ["worse", "equal", "better", "much better", "no evaluation without Velumount"],
                          },
                        },
                      },
                      {
                        properties: {
                          evaluation_sleep: {
                            const: "no",
                          },
                        },
                      },
                    ],
                  },
                },
                description: "",
              },
            }
          : {}),

        ...(has_cpap
          ? {
              fs_cpap_using_2: {
                type: "object",
                title: "",
                properties: {
                  fs_cpap_using_2_title: {
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.title"),
                    type: "string",
                  },
                  sleep_quality: {
                    type: "object",
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.sleep_quality.title"),
                    description: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.sleep_quality.description"),
                    rows: {
                      type: "array",
                      enum: ["sleep_quality_cpap_quality_sleep", "sleep_quality_velumount_quality_sleep"],
                    },
                    columns: {
                      type: "array",
                      enum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    },
                  } as any,

                  life_quality: {
                    type: "object",
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.life_quality.title"),
                    description: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.sleep_quality.description"),
                    rows: {
                      type: "array",
                      enum: ["life_quality_cpap_quality_life", "life_quality_velumount_quality_life"],
                    },
                    columns: {
                      type: "array",
                      enum: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                    },
                  } as any,

                  cpap_using_current_2: {
                    title: t("survey.postsurvey.p_consolidation_users_only.fs_cpap_using_2.cpap_using_current_2.title"),
                    description: "",
                    type: "string",
                    enum: [
                      "always (6-7 times per week)",
                      "often (ca. 2-5 times per week)",
                      "rarly (less than 2 times per week)",
                      "never, but i keep the cpap at home",
                      "never, i retourned the cpap",
                    ],
                  },
                },
                description: "",
              },
            }
          : {}),
      },
      description: "",
    };
  }

  if (page === 3 || page === 999) {
    schema.properties!["p_consolidation_all_users"] = {
      type: "object",
      title: t("survey.postsurvey.p_consolidation_all_users.title"),
      properties: {
        fs_fall_asleep_2: {
          type: "object",
          title: "",
          properties: {
            epworth_title: {
              type: "string",
              title: t("survey.custom.epworth.title"),
            },
            epworth_description: {
              type: "object",
              description: t("survey.custom.epworth.description"),
            },
            epworth: {
              properties: {
                epworth: {
                  type: "object",
                  rows: {
                    type: "array",
                    enum: [
                      "Sitting and readin",
                      "Watching TV",
                      "Sitting, inactive in a public place",
                      "As a passenger in a car for an hour without break",
                      "Lying down to rest in the afternoon",
                      "Sitting an talking to someone",
                      "Sitting quietly after lunch without alcohol",
                      "In a car while stopped for a few minutes in the traffic",
                    ],
                  },
                  columns: {
                    type: "array",
                    enum: ["1", "2", "3", "4"],
                  },
                } as any,
              },
            },
          },
          description: "",
        },
      },
      description: "",
    };
  }

  if (page === 4 || page === 999) {
    schema.properties!["p_consolidation_all_users_2"] = {
      type: "object",
      // title='',
      properties: {
        state_no_product_applicable: {
          type: "number",
        },
        fs_qm_instructor: {
          type: "object",
          title: "",
          properties: {
            fs_qm_instructor_title: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.title"),
              description: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor.title"),
              type: "string",
            },
            // fs_qm_instructor_description: {
            //   description: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor.title"),
            //   type: "string",
            // },

            qm_instructor_appearance: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_appearance.title"),
              description: "",
              type: "number",
            },
            qm_instructor_how_answered_questions: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_how_answered_questions.title"),
              description: "",
              type: "number",
            },
            qm_instructor_competence: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_instructor.qm_instructor_competence.title"),
              description: "",
              type: "number",
            },
          },
        },
        fs_qm_service: {
          type: "object",
          title: "",
          properties: {
            fs_qm_service_title: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.title"),
              type: "string",
            },
            qm_service: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_service.title"),
              description: "",
              type: "number",
            },
            qm_was_group_ws: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_was_group_ws.title"),
              description: "",
              type: "string",
              enum: ["yes", "no"],
            },
            // qm_group_ws_fell: {
            //   title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_group_ws_fell.title"),
            //   description: "",
            //   // TODO: CONDITIONAL RENDERING!!!!!!!!!!!!!
            //   // "#states": { enabled: { ':input[name="qm_was_group_ws"': "yes" }, visible: { ':input[name="qm_was_group_ws"': "yes" } },
            //   type: "string",
            //   enum: ["group_fine", "group_skeptical", "group2single"],
            // },
            qm_ambiance: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_ambiance.title"),
              description: "",
              type: "number",
            },
            qm_duration_ws: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_duration_ws.title"),
              description: "",
              type: "number",
              enum: [45, 60, 75, 90, 120],
            },
          },
          dependencies: {
            qm_was_group_ws: {
              oneOf: [
                {
                  properties: {
                    qm_was_group_ws: {
                      const: "yes",
                    },
                    qm_group_ws_fell: {
                      title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_service.qm_group_ws_fell.title"),
                      description: "",
                      type: "string",
                      enum: ["group_fine", "group_skeptical", "group2single"],
                    },
                  },
                },
                {
                  properties: {
                    qm_was_group_ws: {
                      const: "no",
                    },
                  },
                },
              ],
            },
          },
          description: "",
        },

        fs_qm_recommend: {
          type: "object",
          title: "",
          properties: {
            fs_qm_recommend_title: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.title"),
              description: "",
              type: "string",
            },
            qm_recommend_us: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_qm_recommend.qm_recommend_us.title"),
              description: "",

              type: "number",
            },
          },
          description: "",
        },
        fs_comment: {
          type: "object",
          title: t("survey.postsurvey.p_consolidation_all_users_2.fs_comment.title"),
          properties: {
            comment: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_comment.comment.title"),
              description: "",
              type: "string",
            },
          },
          description: "",
        },
        fs_reaction: {
          type: "object",
          title: t("survey.postsurvey.p_consolidation_all_users_2.fs_reaction.title"),
          properties: {
            reaction_ok: {
              title: t("survey.postsurvey.p_consolidation_all_users_2.fs_reaction.reaction_ok.title"),
              description: "",
              type: "string",
              enum: ["yes", "no"],
            },
          },
          description: "",
        },
      },
      description: "",
      dependencies: {
        // "#states": { "enabled": [{ ":input[name=\"how_often\"": "never" }], "visible": [{ ":input[name=\"how_often\"": "never" }] }
        state_no_product_applicable: {
          oneOf: [
            {
              properties: {
                state_no_product_applicable: {
                  const: 0,
                },
                finalDescription: {
                  description: t("survey.postsurvey.fs_final.description"),
                  type: "string",
                },
              },
            },
            {
              properties: {
                state_no_product_applicable: {
                  const: 1,
                },
                breakDescription: {
                  description: t("survey.postsurvey.fs_break.description"),
                  type: "string",
                },
              },
            },
          ],
        },
      },
    };

    schema.properties!["ess_initial"] = {
      title: t("survey.postsurvey.ess_initial.title"),
      description: "",
      type: "string",
    };

    schema.properties!["ess_new"] = {
      title: t("survey.postsurvey.ess_new.title"),
      description: "",

      type: "string",
    };

    schema.properties!["ess_diff"] = {
      title: t("survey.postsurvey.ess_diff.title"),

      description: "",
      type: "string",
    };
  }

  return schema;
};
